import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Search,
    Plus,
    Filter,
    MoreHorizontal,
    Mail,
    Phone,
    Trash2,
    Edit2,
    GraduationCap,
    Clock,
    BookOpen
} from 'lucide-react';

export default function TeacherList() {
    const teachersData = [
        { sn: '01', name: 'Dr. Sarah Johnson', subject: 'Mathematics', joined: 'Jan 2020', workload: '24 hrs/wk', status: 'Active' },
        { sn: '02', name: 'Prof. Michael Smith', subject: 'Physics', joined: 'Mar 2021', workload: '20 hrs/wk', status: 'Active' },
        { sn: '03', name: 'Emma Wilson', subject: 'Chemistry', joined: 'Aug 2022', workload: '18 hrs/wk', status: 'On Leave' },
        { sn: '04', name: 'James Davis', subject: 'Computer Science', joined: 'Feb 2019', workload: '28 hrs/wk', status: 'Active' },
        { sn: '05', name: 'Oliver Miller', subject: 'English', joined: 'Sep 2023', workload: '15 hrs/wk', status: 'Active' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Faculty Management"
                    subtitle="Directory of academic staff and department personnel"
                >
                    <div className="relative group">
                        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                        <input
                            type="text"
                            placeholder="Name, Subject or Department..."
                            className="pl-11 pr-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all w-64"
                        />
                    </div>

                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Add New Faculty
                    </button>
                </Header>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-10">
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Total Faculty</p>
                        <h4 className="text-[28px] font-black text-[#111827]">84</h4>
                    </div>
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm font-sans">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Active Now</p>
                        <h4 className="text-[28px] font-black text-emerald-500">76</h4>
                    </div>
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">On Leave</p>
                        <h4 className="text-[28px] font-black text-amber-500">08</h4>
                    </div>
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Vacant Posts</p>
                        <h4 className="text-[28px] font-black text-rose-500">03</h4>
                    </div>
                </div>

                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <h3 className="text-[20px] font-black text-[#111827]">Faculty directory</h3>
                        <button className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors">
                            <MoreHorizontal size={22} />
                        </button>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Staff Member</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Primary Subject</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Workload</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Joined Date</th>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Status</th>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {teachersData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5">
                                            <div className="flex items-center gap-4">
                                                <div className="w-11 h-11 rounded-xl bg-orange-50 text-orange-500 flex items-center justify-center font-black group-hover:scale-105 transition-transform overflow-hidden">
                                                    <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${v.name}`} alt="" />
                                                </div>
                                                <div>
                                                    <p className="text-[15px] font-black text-[#111827] mb-0.5">{v.name}</p>
                                                    <p className="text-[12px] font-bold text-gray-400 uppercase tracking-tighter">ID: TCH-0{v.sn}2</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-2 text-[14px] font-bold text-gray-700 uppercase tracking-tight">
                                                <BookOpen size={14} className="text-blue-500" />
                                                {v.subject}
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-2 text-[14px] font-bold text-gray-500">
                                                <Clock size={14} className="text-gray-400" />
                                                {v.workload}
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-center text-[13px] font-bold text-gray-400">{v.joined}</td>
                                        <td className="px-8 py-5 text-center">
                                            <span className={`text-[11px] font-black px-3 py-1.5 rounded-lg uppercase tracking-widest ${v.status === 'Active' ? 'text-emerald-500 bg-emerald-50' : 'text-amber-500 bg-amber-50'
                                                }`}>
                                                {v.status}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-1">
                                                <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all"><Edit2 size={16} /></button>
                                                <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all"><Mail size={16} /></button>
                                                <button className="p-2 text-gray-400 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all"><Trash2 size={16} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </main>
        </div>
    );
}
